export enum OrganizationPermissions {
  ManageSso = 'sso-management',
  ViewTaxId = 'aim-producer-view-tax-id',
  SearchProducer = 'aim-producer-search',
  SearchAllProducer = 'aim-producer-search-all',
  ModifySettings = 'aim-producer-modify',
  RequestEdit = 'aim-producer-request-edit',
  ModifyContacts = 'aim-producer-contact-modify',
  EditUsers = 'edit-users',
  AccessUserManagement = 'access-user-management',
  SearchChangeRequest = 'change-request-search',
  EditChangeRequest = 'change-request-edit',
  EditAllChangeRequest = 'change-request-edit-all',
  SearchAllChangeRequest = 'change-request-search-all',
  SearchQuote = 'aim-quote-search',
  SearchAllQuote = 'aim-quote-search-all',
  SearchInvoice = 'aim-invoice-search',
  ViewStatements = 'statements-view',
  ViewRelatedStatements = 'statements-view-related',
  ViewUnrestrictedStatements = 'statements-view-unrestricted',
  AccessReports = 'aim-quote-report',
  ViewOnboardingApplication = 'view-onboarding-application',
  AccessLucantha = 'access-lucantha'
}